// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compliance-container {
  max-width: 950px;
  margin: auto;
  padding: 60px 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.compliance-breadcrumb {
  font-size: 14px;
  margin-bottom: 24px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.breadcrumb-link {
  color: #c3cbd4;

  cursor: pointer;
}

.breadcrumb-arrow {
  color: #aaa;
}

.breadcrumb-current {
  font-weight: bold;
  color: #222;
}

.compliance-title {
  font-size: 32px;
  font-weight: bold;
  color: #1b4332;
  margin-bottom: 8px;
}

.compliance-subtitle {
  font-size: 16px;
  color: #444;
  margin-bottom: 40px;
}

.compliance-card-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.compliance-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  text-decoration: none;
  padding: 18px 22px;
  border-radius: 12px;
  transition: 0.3s ease;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid transparent;
  color: #0b5307;
}

.compliance-card:hover {
  background-color: #eafaf1;
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 128, 0, 0.08);
  border-color: #c3f4d6;
}

.compliance-card-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.compliance-icon {
  font-size: 20px;
  color: #2d6a4f;
  background-color: #d3f9d8;
  padding: 8px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compliance-text {
  font-size: 16px;
  color: #222;
  
}
@media (max-width: 900px) {

  /* layout stacking */
  .main-wrapper {
    grid-template-columns: 1fr;
    gap: 20px;
    margin: 20px auto 40px;
  }

  /* horizontal scroll tabs */
  .nav-list {
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 10px;
    gap: 10px;
    scrollbar-width: none;
  }

  .nav-list::-webkit-scrollbar {
    display: none;
  }

  .nav-item {
    min-width: 200px;
    padding: 12px;
  }

  .nav-title {
    font-size: 13px;
  }

  .nav-tagline {
    font-size: 11px;
  }

  /* hero section */
  .hero-banner {
    height: auto;
    padding: 30px 15px;
  }

  .hero-banner h1 {
    font-size: 22px;
  }

  .hero-banner p {
    font-size: 13px;
  }

  /* list items */
  .list-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 15px;
  }

  .item-info h4 {
    font-size: 14px;
  }

  .item-info span {
    font-size: 12px;
  }

  .badge {
    font-size: 10px;
    padding: 3px 8px;
  }

  /* right side arrow + badge alignment */
  .list-item > div:last-child {
    width: 100%;
    justify-content: space-between;
  }

  /* footer buttons stack */
  footer div[style*="flex"] {
    flex-direction: column !important;
    gap: 10px !important;
  }

  footer button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ComplianceCenter.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;;AAEb;AACA;;EAEE,oBAAoB;EACpB;IACE,0BAA0B;IAC1B,SAAS;IACT,sBAAsB;EACxB;;EAEA,2BAA2B;EAC3B;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA,yBAAyB;EACzB;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".compliance-container {\r\n  max-width: 950px;\r\n  margin: auto;\r\n  padding: 60px 20px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.compliance-breadcrumb {\r\n  font-size: 14px;\r\n  margin-bottom: 24px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.breadcrumb-link {\r\n  color: #c3cbd4;\r\n\r\n  cursor: pointer;\r\n}\r\n\r\n.breadcrumb-arrow {\r\n  color: #aaa;\r\n}\r\n\r\n.breadcrumb-current {\r\n  font-weight: bold;\r\n  color: #222;\r\n}\r\n\r\n.compliance-title {\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  color: #1b4332;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.compliance-subtitle {\r\n  font-size: 16px;\r\n  color: #444;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.compliance-card-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.compliance-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: #f9f9f9;\r\n  text-decoration: none;\r\n  padding: 18px 22px;\r\n  border-radius: 12px;\r\n  transition: 0.3s ease;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n  border: 1px solid transparent;\r\n  color: #0b5307;\r\n}\r\n\r\n.compliance-card:hover {\r\n  background-color: #eafaf1;\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 20px rgba(0, 128, 0, 0.08);\r\n  border-color: #c3f4d6;\r\n}\r\n\r\n.compliance-card-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n}\r\n\r\n.compliance-icon {\r\n  font-size: 20px;\r\n  color: #2d6a4f;\r\n  background-color: #d3f9d8;\r\n  padding: 8px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.compliance-text {\r\n  font-size: 16px;\r\n  color: #222;\r\n  \r\n}\r\n@media (max-width: 900px) {\r\n\r\n  /* layout stacking */\r\n  .main-wrapper {\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n    margin: 20px auto 40px;\r\n  }\r\n\r\n  /* horizontal scroll tabs */\r\n  .nav-list {\r\n    flex-direction: row;\r\n    overflow-x: auto;\r\n    padding-bottom: 10px;\r\n    gap: 10px;\r\n    scrollbar-width: none;\r\n  }\r\n\r\n  .nav-list::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .nav-item {\r\n    min-width: 200px;\r\n    padding: 12px;\r\n  }\r\n\r\n  .nav-title {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .nav-tagline {\r\n    font-size: 11px;\r\n  }\r\n\r\n  /* hero section */\r\n  .hero-banner {\r\n    height: auto;\r\n    padding: 30px 15px;\r\n  }\r\n\r\n  .hero-banner h1 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .hero-banner p {\r\n    font-size: 13px;\r\n  }\r\n\r\n  /* list items */\r\n  .list-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    padding: 15px;\r\n  }\r\n\r\n  .item-info h4 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .item-info span {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .badge {\r\n    font-size: 10px;\r\n    padding: 3px 8px;\r\n  }\r\n\r\n  /* right side arrow + badge alignment */\r\n  .list-item > div:last-child {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  /* footer buttons stack */\r\n  footer div[style*=\"flex\"] {\r\n    flex-direction: column !important;\r\n    gap: 10px !important;\r\n  }\r\n\r\n  footer button {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
